export interface DomicileNotice {
  entity: string;
  link: string;
}
